import { render, staticRenderFns } from "./OptimizationGallery.vue?vue&type=template&id=ee67267e"
import script from "./OptimizationGallery.vue?vue&type=script&lang=js"
export * from "./OptimizationGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports